import { useEffect, useRef } from 'react';

export const useHotkeys = (shortcuts) => {
  const shortcutsRef = useRef(shortcuts);
  shortcutsRef.current = shortcuts;

  useEffect(() => {
    const handler = (e) => {
      const tag = e.target.tagName;
      const isInput = tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || e.target.isContentEditable;

      for (const [combo, config] of Object.entries(shortcutsRef.current)) {
        const { handler: fn, allowInInput = false, preventDefault = true } = typeof config === 'function'
          ? { handler: config } : config;

        if (isInput && !allowInInput) continue;

        const parts = combo.toLowerCase().split('+');
        const key = parts.pop();
        const needCtrl = parts.includes('ctrl') || parts.includes('mod');
        const needShift = parts.includes('shift');
        const needAlt = parts.includes('alt');
        const isMac = navigator.userAgent.includes('Mac');
        const ctrlMatch = needCtrl ? (isMac ? e.metaKey : e.ctrlKey) : !(e.metaKey || e.ctrlKey);
        const shiftMatch = needShift ? e.shiftKey : !e.shiftKey;
        const altMatch = needAlt ? e.altKey : !e.altKey;

        if (e.key.toLowerCase() === key && ctrlMatch && shiftMatch && altMatch) {
          if (preventDefault) e.preventDefault();
          fn(e);
          return;
        }
      }
    };

    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, []);
};

export const getShortcutLabel = (combo) => {
  const isMac = typeof navigator !== 'undefined' && navigator.userAgent.includes('Mac');
  return combo
    .replace(/mod/gi, isMac ? '\u2318' : 'Ctrl')
    .replace(/ctrl/gi, isMac ? '\u2318' : 'Ctrl')
    .replace(/shift/gi, isMac ? '\u21E7' : 'Shift')
    .replace(/alt/gi, isMac ? '\u2325' : 'Alt')
    .replace(/\+/g, ' + ')
    .replace(/\b\w/g, c => c.toUpperCase());
};
